/* ==========================================================================
   Homara Deco - logica de las piezas de conversion v15.
     1. Barra de escasez (anima al entrar en pantalla)
     2. Linea "Estas ahorrando $X en este pedido" (sigue al combo elegido)
     3. Reloj de la oferta (cuenta regresiva a una fecha fija)
     4. Antes / despues arrastrable
     5. La cuenta: objecion de precio
   Cada bloque es independiente: si uno falla, los otros siguen.
   ========================================================================== */
(function () {
  'use strict';

  function pesos(n) {
    try { return '$' + Math.round(n).toLocaleString('es-AR'); }
    catch (e) { return '$' + Math.round(n); }
  }

  /* ---------- 1. Escasez ---------- */
  function escasez() {
    var cajas = document.querySelectorAll('[data-hd-escasez]');
    if (!cajas.length) return;

    function llenar(caja) {
      var pct = parseInt(caja.dataset.hdEscasez, 10);
      if (isNaN(pct)) pct = 80;
      if (pct < 1) pct = 1;
      if (pct > 100) pct = 100;
      var barra = caja.querySelector('[data-hd-escasez-barra]');
      if (barra) barra.style.width = pct + '%';
    }

    if (!('IntersectionObserver' in window)) {
      cajas.forEach(llenar);
      return;
    }
    var ojo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        llenar(e.target);
        ojo.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    cajas.forEach(function (c) { ojo.observe(c); });
  }

  /* ---------- 2. Ahorro del pedido ---------- */
  function ahorro() {
    var lineas = document.querySelectorAll('[data-hd-ahorro-pedido]');
    if (!lineas.length) return;

    function pintar() {
      lineas.forEach(function (linea) {
        var raiz = linea.closest('.shopify-section') || document;
        var elegida = raiz.querySelector('[data-hd-opcion][aria-checked="true"]');
        var monto = elegida ? parseInt(elegida.dataset.ahorro || '0', 10) : 0;
        if (!monto || monto <= 0) {
          linea.hidden = true;
          return;
        }
        var hueco = linea.querySelector('[data-hd-ahorro-monto]');
        if (hueco) hueco.textContent = pesos(monto / 100);
        linea.hidden = false;
      });
    }

    pintar();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-hd-opcion]')) {
        window.setTimeout(pintar, 30);
      }
    });
  }

  /* ---------- 3. Reloj ---------- */
  function reloj() {
    var relojes = document.querySelectorAll('[data-hd-reloj]');
    if (!relojes.length) return;

    relojes.forEach(function (caja) {
      var fin = Date.parse(caja.dataset.hdReloj);
      if (isNaN(fin)) { caja.hidden = true; return; }

      var d = caja.querySelector('[data-hd-reloj-d]');
      var h = caja.querySelector('[data-hd-reloj-h]');
      var m = caja.querySelector('[data-hd-reloj-m]');
      var s = caja.querySelector('[data-hd-reloj-s]');

      function dos(n) { return n < 10 ? '0' + n : '' + n; }

      function tic() {
        var falta = fin - Date.now();
        if (falta <= 0) { caja.hidden = true; return; }
        var seg = Math.floor(falta / 1000);
        if (d) d.textContent = dos(Math.floor(seg / 86400));
        if (h) h.textContent = dos(Math.floor(seg % 86400 / 3600));
        if (m) m.textContent = dos(Math.floor(seg % 3600 / 60));
        if (s) s.textContent = dos(seg % 60);
        caja.hidden = false;
      }

      tic();
      window.setInterval(tic, 1000);
    });
  }

  /* ---------- 4. Antes / despues ---------- */
  function antesDespues() {
    document.querySelectorAll('[data-hd-ad]').forEach(function (marco) {
      if (marco.dataset.hdAdListo === '1') return;
      marco.dataset.hdAdListo = '1';

      var frente = marco.querySelector('.hd-ad__capa--frente');
      var tirador = marco.querySelector('[data-hd-ad-tirador]');
      var rango = marco.querySelector('[data-hd-ad-rango]');
      if (!frente || !tirador) return;

      function mover(pct) {
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        frente.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        tirador.style.insetInlineStart = pct + '%';
        if (rango && Number(rango.value) !== Math.round(pct)) rango.value = Math.round(pct);
      }

      function desdeX(x) {
        var caja = marco.getBoundingClientRect();
        if (!caja.width) return;
        mover((x - caja.left) / caja.width * 100);
      }

      var arrastrando = false;
      marco.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        marco.setPointerCapture(e.pointerId);
        desdeX(e.clientX);
      });
      marco.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        desdeX(e.clientX);
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        marco.addEventListener(ev, function () { arrastrando = false; });
      });
      if (rango) {
        rango.addEventListener('input', function () { mover(Number(rango.value)); });
      }

      mover(Number(marco.dataset.hdAd || 50));
    });
  }

  /* ---------- 5. La cuenta ---------- */
  function laCuenta() {
    document.querySelectorAll('[data-hd-cuenta]').forEach(function (caja) {
      var precio = parseInt(caja.dataset.hdPrecio || '0', 10) / 100;
      var anios = caja.querySelector('[data-hd-cuenta-anios]');
      var veces = caja.querySelector('[data-hd-cuenta-veces]');
      var salAnios = caja.querySelector('[data-hd-sal-anios]');
      var salVeces = caja.querySelector('[data-hd-sal-veces]');
      var grande = caja.querySelector('[data-hd-cuenta-grande]');
      var chico = caja.querySelector('[data-hd-cuenta-chico]');
      if (!anios || !veces || !grande) return;

      function calcular() {
        var a = Number(anios.value);
        var v = Number(veces.value);
        var usos = a * 52 * v;
        var porUso = usos > 0 ? precio / usos : precio;

        if (salAnios) salAnios.textContent = a + (a === 1 ? ' año' : ' años');
        if (salVeces) salVeces.textContent = v + (v === 1 ? ' vez por semana' : ' veces por semana');

        var txt = porUso >= 1 ? pesos(porUso) : '$' + porUso.toFixed(2).replace('.', ',');
        grande.textContent = txt;
        if (chico) {
          chico.textContent = 'Eso es lo que te sale pisar seco cada vez que salís de la ducha, durante ' +
            a + (a === 1 ? ' año' : ' años') + ' (' + usos.toLocaleString('es-AR') + ' veces).';
        }
      }

      anios.addEventListener('input', calcular);
      veces.addEventListener('input', calcular);
      calcular();
    });
  }

  function arrancar() {
    [escasez, ahorro, reloj, antesDespues, laCuenta].forEach(function (f) {
      try { f(); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else { arrancar(); }
  document.addEventListener('shopify:section:load', arrancar);
})();
